<template>
  <div class="card mb-4">
    <div class="card-header pb-3">
      <div class="row g-3 align-items-center">
        <div class="col-12 col-md-6">
          <h5 class="mb-2 text-dark">Trabajadores del Recreativo</h5>
          <span class="badge bg-gradient-dark">
            <i class="fa fa-users me-1" aria-hidden="true"></i>{{ customers.total || 0 }} trabajadores
          </span>
        </div>
        <div class="col-12 col-md-6">
          <div class="d-flex justify-content-md-end">
            <input
              id="search-customers"
              v-model="search"
              @input="searchCustomers"
              type="text"
              class="form-control"
              style="max-width: 240px;"
              placeholder="Buscar por nombre o matrícula"
              aria-label="Buscar trabajador por nombre o matrícula"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table table-hover zebra align-items-center mb-0">
          <thead>
            <tr>
              <th class="sortable text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-4" @click="setSort('name')">
                Nombre <i class="fas ms-1" :class="sortIcon('name')" aria-hidden="true"></i>
              </th>
              <th class="sortable text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="setSort('matricula')">
                Matrícula <i class="fas ms-1" :class="sortIcon('matricula')" aria-hidden="true"></i>
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Teléfono</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Email</th>
              <th class="sortable text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="setSort('children')">
                Hijos <i class="fas ms-1" :class="sortIcon('children')" aria-hidden="true"></i>
              </th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">Ver</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="isLoading">
              <tr v-for="n in 8" :key="'sk' + n">
                <td class="ps-4"><div class="skeleton" style="width: 70%"></div></td>
                <td><div class="skeleton" style="width: 50%"></div></td>
                <td><div class="skeleton" style="width: 60%"></div></td>
                <td><div class="skeleton mx-auto" style="width: 70%"></div></td>
                <td><div class="skeleton mx-auto" style="width: 30%"></div></td>
                <td><div class="skeleton mx-auto" style="width: 30%"></div></td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="customer in customers.data" :key="customer.id" class="cursor-pointer" @click="openRecord(customer.id)">
                <td class="ps-4">
                  <h6 class="mb-0 text-sm">{{ customer.name || (customer.first_name + ' ' + customer.last_name) }}</h6>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">{{ customer.matricula || '—' }}</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">{{ customer.phone }}</p>
                </td>
                <td class="align-middle text-center">
                  <p class="text-xs font-weight-bold mb-0">{{ customer.email }}</p>
                </td>
                <td class="align-middle text-center">
                  <p class="text-xs font-weight-bold mb-0">{{ customer.youths.length + customer.infants.length }}</p>
                </td>
                <td class="align-middle text-center">
                  <button class="btn btn-link text-secondary mb-0 p-1" aria-label="Ver trabajador" @click.stop="openRecord(customer.id)">
                    <i class="fas fa-eye" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <!-- Empty state -->
        <div v-if="!isLoading && !customers.data.length" class="empty-state text-center">
          <div class="empty-icon mx-auto mb-3">
            <i class="fas fa-users" aria-hidden="true"></i>
          </div>
          <h6 class="text-dark mb-1">Sin trabajadores</h6>
          <p class="text-sm text-secondary mb-0">
            {{ search ? 'No encontramos resultados para tu búsqueda.' : 'Aún no hay trabajadores registrados.' }}
          </p>
        </div>
      </div>
      <div v-if="!isLoading && customers.data.length" class="d-flex justify-content-end align-items-center px-4 py-3">
        <div class="d-flex align-items-center">
          <label class="me-2">Mostrar:</label>
          <select v-model="perPage" @change="fetchCustomers" class="form-select me-3">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
        <button @click="changePage('first')" :disabled="!customers.prev_page_url" class="btn btn-primary btn-sm me-2">Primera</button>
        <button @click="changePage('prev')" :disabled="!customers.prev_page_url" class="btn btn-primary btn-sm me-2">Anterior</button>
        <span>Página {{ customers.current_page }} de {{ customers.last_page }}</span>
        <button @click="changePage('next')" :disabled="!customers.next_page_url" class="btn btn-primary btn-sm me-2">Siguiente</button>
        <button @click="changePage('last')" :disabled="customers.current_page === customers.last_page" class="btn btn-primary btn-sm">Última</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const PUBLIC_API_URL = process.env.VUE_APP_PUBLIC_API_URL;
export default {
  name: "trabajadores-table",
  data() {
    return {
      customers: { data: [] },
      search: '',
      currentPage: 1,
      perPage: 20,
      sortBy: 'name',
      sortDir: 'asc',
      isLoading: false,
    };
  },
  created() {
    this.fetchCustomers();
  },
  methods: {
    fetchCustomers() {
      this.isLoading = true;
      const params = {
        page: this.currentPage,
        per_page: this.perPage,
        search: this.search,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
      };
      axios.get(`${PUBLIC_API_URL}/customers`, { params })
        .then(response => {
          this.customers = response.data;
        })
        .catch(error => {
          console.error("There was an error fetching the customers!", error);
          this.customers = { data: [] };
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changePage(direction) {
      if (direction === 'next' && this.customers.next_page_url) {
        this.currentPage++;
      } else if (direction === 'prev' && this.customers.prev_page_url) {
        this.currentPage--;
      } else if (direction === 'first') {
        this.currentPage = 1;
      } else if (direction === 'last') {
        this.currentPage = this.customers.last_page;
      }
      this.fetchCustomers();
    },
    searchCustomers() {
      this.currentPage = 1;
      this.fetchCustomers();
    },
    openRecord(id) {
      this.$router.push(`/trabajadores/${id}`);
    },
    setSort(column) {
      if (this.sortBy === column) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortBy = column;
        this.sortDir = 'asc';
      }
      this.currentPage = 1;
      this.fetchCustomers();
    },
    sortIcon(column) {
      if (this.sortBy !== column) return 'fa-sort opacity-5';
      return this.sortDir === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
    }
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.table.zebra tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}
.table.zebra tbody tr:hover {
  background-color: #eef2f7;
}
.sortable {
  cursor: pointer;
  user-select: none;
}
.sortable:hover {
  color: #344767 !important;
}
.skeleton {
  height: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg, #edf0f3 25%, #f7f9fb 37%, #edf0f3 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
}
@keyframes shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}
.empty-state {
  padding: 3.5rem 1.5rem;
}
.empty-icon {
  width: 4.5rem;
  height: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #eef2f7 0%, #e3e9f2 100%);
  color: #8392ab;
  font-size: 1.8rem;
}
</style>
